import { get, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchCommissionsList = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("referandearn/user-wise-commission-summary/list?searchFilter=" + data.searchFilter + "&userID=" + data.userID + "&statusName=" + encodeURIComponent(data.statusName));
    }, options);
};

export const useUpdateCommissions = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("referandearn/commission-pay-proof/submit", data);
    }, options);
};
